import WebGL2Component from '@/components/core/WebGLComponent';
import { getCorsPath } from '@/lib/utils';

type TopographicalVideoMapProps = {
  image?: string;
  video?: string;
  overlay?: string;
  color?: [number, number, number, number];
};

export default function TopographicalVideoMap({
  image,
  video,
  overlay = '/assets/topographical-map-4.png',
  color = [0.122, 0.122, 0.122, 0.5],
}: TopographicalVideoMapProps) {
  return (
    <WebGL2Component
      overlay={overlay}
      video={getCorsPath(video)}
      image={getCorsPath(image)}
      color={color}
    />
  );
}
